import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/me14.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
  return (
    <header className="header">
      <div className="container header__container">
        <div className="header__content">
          <div className="header__intro">
            <h5 className="header__greeting">Hey There! 👋</h5>
            <h1 className="header__name">I'm Abrar Hoque</h1>
            <h5 className="header__title">A Fullstack Developer and a Tech Enthusiast</h5>
            <CTA />
          </div>
          
          <div className="header__visual">
            <div className="me">
              <img src={ME} alt="Abrar Hoque" className="me-image" />
            </div>
            <HeaderSocial />
          </div>
        </div>
        
        <a href="#contact" className="scroll__down">
          <span>Scroll Down</span>
          <div className="scroll__icon"></div>
        </a>
      </div>
    </header>
  )
}

export default Header
